module.exports = __webpack_public_path__ + "img/CY110006.bd29d677.png";